module.exports = __webpack_public_path__ + "media/images/back-arrow-59748c69d53c55005b34eb730e544bac.png";